<template>
  <div class="pv3 ph4 ph5-l bg-white tc bs--booking-tool">
    <p class="f-smallest fw5 ttu mb2 mb3-l">{{ translations.selectLocation }}</p>

    <div class="mb3-l">
      <ul class="list tl">
        <li v-for="option in locationOptions" :key="option.hotel">
          <div class="radio">
            <input
              @input="onInput"
              type="radio"
              name="locationOption"
              :value="option.hotel"
              :id="option.hotel"
            />
            <label :for="option.hotel" class="flex items-center">{{ option.locationName }}</label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import h from "../helpers"
import s from "../store"

export default {
  name: "RadioListMobile",

  data() {
    return {
      sharedState: s.state,
      isOpen: false
    }
  },

  props: {
    locationOptions: { type: Array },
    themeSite: String,
    translations: { type: Object }
  },

  created() {
    if (s.debug)
      console.log("created RadioListMobile with", this.locationOptions)
  },

  computed: {
    bookingParams: function() {
      return h.serializeObject(s.state.booking)
    },
    locationValue: function() {
      return s.getLocation(s.state.activeHotel) || this.translations.location
    }
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside)
      }
    }
  },

  methods: {
    submitBookRoomValue: function() {
      this.handleMewsOpen(this.sharedState)
    },

    onInput: function(location) {
      this.sharedState.activeHotel = location.target.value

      s.setBookingScriptSettings(location.target.value)

      this.submitBookRoomValue()
    },

    closeIfClickedOutside(event) {
      if (!event.target.closest(".radiolist")) {
        this.isOpen = false
        document.removeEventListener("click", this.closeIfClickedOutside)
      }
    }
  }
}
</script>
